module.exports = __webpack_public_path__ + "static/img/limit_watch_video.1605319.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/liveDialog/limit_watch_video.png
// module id = 23w0
// module chunks = 0